import React, { useState }from "react";
import ItemImageGalleryModal from "@/items/components/ItemImageGalleryModal";
import { getReadableHoldStatus, holdKey, getStatusStyle } from "@/utility/HoldUtils";
import { TextField } from "@mui/material"
import Creatable from 'react-select/creatable'
import Select, {components} from 'react-select'

export const getOnsiteColumns = () => {
  return [
    {
      id: "item",
      label: "Item",
      renderCell: renderItemCell,
      valueGetter: (row, column) => {
        return row.name
      },
      customSort: (rows, column, sortDirection)=>{ 
        return rows.sort((a, b)=>{
          let aName = (a.name||"").toLowerCase()
          let bName = (b.name||"").toLowerCase()
          //If a starts with a number
          if(aName[0] >= '0' && aName[0] <= '9') {
            aName = "zzzzzz"+aName
          }
          if(bName[0] >= '0' && bName[0] <= '9') {
            bName = "zzzzzz"+bName
          }
          if(sortDirection == "asc") {
            return aName < bName ? -1 : 1
          }else {
            return aName > bName ? -1 : 1
          }
          
        })
      },
      renderCellExport: (row, column) => {
        return row.name
      },
      width: 300
    },
    {
      id: "reserved",
      cellClassName:"font-bold",
      label: "Reserved",
    },
    {
      id: "qty-shipped",
      label: "QTY Shipped",
      valueGetter: (row, column) => {
        return row.hold?.total_packed || 0
      },
    },
    {
      id: 'location',
      label: "Distribution Location",
      valueGetter: (row, column) => {
        return row.hold?.event_location?.name
      }
    },
    {
      id: "pallet-number",
      label: "Pallet #",

      valueGetter: (row, column) => {
        return row.hold?.pallet_number||""
      },
    },
    {
      id: "truck-number",
      label: "Truck #",
       valueGetter: (row, column) => {
        return (row.hold?.truck_number||"")
      },
    },
    {
      id: "onsite_checked_in",
      label: "Checked In",
      cellClassName:"px-4",
      sorting: false,

      valueGetter: (row, column) => {
        return row.onsite_checked_in || 0
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {onsite_checked_in: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.onsite_checked_in || 0
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            type: "number"
          }})
        })
      )
    },
    {
      id: "onsite_collected",
      label: "Collected",
      cellClassName:"px-4",
      sorting: false,

      valueGetter: (row, column) => {
        return row.onsite_collected || 0
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {onsite_collected: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.onsite_collected || 0
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            type: "number"
          }})
        })
      )
    },
    {
      id: "onsite_notes",
      label: "Onsite Notes",
      cellClassName:"px-4",
      sorting: false,

      valueGetter: (row, column) => {
        return row.onsite_notes 
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {onsite_notes: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.onsite_collected
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            multiline: true,
            maxHeight: "29px"
          }})
        })
      )
    },

  ]
}

const renderPalletCell = (row, column, hold) => {
  const height = "24px"
  return (
    <Creatable
      className="w-full"
      classNamePrefix="sg-manifest-pallet-select"
      isClearable
      value={hold.pallet ? {label: hold.pallet.name, value: hold.pallet.id} : null}
      placeholder="Pallet"
      options={row.palletOptions}
      onChange={(e) =>{
        console.log(e);
        row.updateItemHold(hold.id, {pallet: e.value, item_hold: {id: hold.id}})
      }}
      styles={{
        control: (provided, state) => ({
          ...provided,
          height: height,
          minHeight: height,
          border: "0",
          borderRadius: "0",
          fontSize: "12px",
        }),
        singleValue: provided => ({
          ...provided,
          fontWeight: "bold",
        }),
        placeholder: provided => ({
          ...provided,
          fontWeight: "bold",
        }),
        menu: (base) => ({
              ...base,
              width: "max-content",
              minWidth: "100%"
        }),
        indicatorSeparator: base => ({
          ...base,
          display: 'none'
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          height: height,
          padding: '0 6px',
          width: "100px"
        }),
          indicatorsContainer: (provided, state) => ({
          ...provided,
          height: height,
        }),
      }}
      components={{
        SingleValue: ({ children, ...props }) => {
          return (
            <components.SingleValue {...props}>
              {children}
            </components.SingleValue>
          );
        },
        IndicatorSeparator: () => null
      }}
    />
  );
}

const renderEditableTextField = (row, column, params) => {
  return (
    <EditableTextField row={row} column={column} params={params} />
  )
}
const EditableTextField = ({row, column, params}) => {
  const [ showMore, setShowMore ] = useState(false)
  return (
    <div className="flex flex-start">
      <TextField 
        size="small"
        variant="standard"
        className="mt-[-1px] text-center text-[#666]"
        InputProps={{
          style:{
            display: "flex",
            backgroundColor: showMore ? "#f5f5f5" : "transparent",
            alignItems:"flex-start",
            zIndex: showMore ? 1 : 0,
            
          }
        }}
        onFocus={()=>{
          setShowMore(true)
        }}
        onBlur={()=>{
          setShowMore(false)
        }}
        key={`textfield-${column.id}-${row.id}`}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
        value={column.valueGetter(row, column)}
        onChange={(e) =>{
          column.valueSetter(row, column, e.target.value)
        }}
        {
          ...params.fieldProps
        }
        fullWidth
        inputProps={{
          min: 0,
          style: {
            fontSize: "16px",
            color: "#666",
            textAlign: "center",
            lineHeight: "24px"
          }
        }}
    />
    </div>
  )
}




export const getShippingColumns = () => {
  return [
    {
      id: "item",
      label: "Item",
      renderCell: renderItemCell,
      valueGetter: (row, column) => {
        return row.name
      },
      renderCellExport: (row, column) => {
        return row.name
      },
      customSort: (rows, column, sortDirection)=>{ 
        return rows.sort((a, b)=>{
          let aName = (a.name||"").toLowerCase()
          let bName = (b.name||"").toLowerCase()
          //If a starts with a number
          if(aName[0] >= '0' && aName[0] <= '9') {
            aName = "zzzzzz"+aName
          }
          if(bName[0] >= '0' && bName[0] <= '9') {
            bName = "zzzzzz"+bName
          }
          if(sortDirection == "asc") {
            return aName < bName ? -1 : 1
          }else {
            return aName > bName ? -1 : 1
          }
          
        })
      },
      width: 300
    },
    
    {
      id: 'owner',
      label: "Owner",
    },
    {
      id: "reserved",
      cellClassName:"font-bold",
      label: "Reserved",
    },
    {
      id: "currently_in_warehouse",
      label: "In Stock",
      renderCell: (row) => (
        <span
          className={row.currently_in_warehouse < row.reserved ? "text-[#E60073]" : ""}
        >
          {row.currently_in_warehouse}
        </span>
      )
    },
    {
      id: "status",
      label: "Status",
      className:"min-w-[150px]",
      cellClassName:"px-4",
      width: 150,
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return getReadableHoldStatus({status: hold.status})
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderHoldStatusSelector(row, hold, item, column)
        })
      ),
      sorting: false
    },
    {
      id: "qty-shipped",
      label: "QTY Shipped",
      cellClassName:"px-4",
      valueGetter: (row, column) => {
        return row.total_packed || 0
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {total_packed: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.total_packed || 0
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            type: "number"
          }})
        })
      )
    },
    {
      id: 'location',
      label: "Distribution Location",
      valueGetter: (row, column) => {
        //Strip string of trailign spaces
        return (row?.hold.location||"").trim()
      },
    },
    { 
      id: "pallet_number",
      label: "Pallet #",
      cellClassName:"px-4",
      valueGetter: (row, column) => {
        return row.pallet_number
      },
      renderCellExport: (row, column) => {
        return row.hold?.pallet_number
      },
      valueSetter: (row, column, value) => {
        row.pallet_number = value
        row.updateItemHold(row.id, {pallet_number: value})
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            multiline: true,
            maxHeight: "29px"
          }})
        })
      ),
      sorting: false
    },
    {
      id: "truck_number",
      label: "Truck #",
      cellClassName:"px-4",
      sorting: false,
      valueGetter: (row, column) => {
        return row.truck_number
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {truck_number: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.truck_number || "No Truck Assigned Yet"
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            multiline: true,
            maxHeight: "29px"
          }})
        })
      )
    },
    { 
      id: "notes",
      label: "Hold Notes",
      cellClassName:"px-4",
      valueGetter: (row, column) => {
        return row.notes
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.notes
        }).join(",\n")
      },
      valueSetter: (row, column, value) => {
        row.notes = value
        row.updateItemHold(row.id, {notes: value})
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            multiline: true,
            maxHeight: "70px"
            
          }})
        })
      ),
      sorting: false
    },
  ]
}

export const renderHoldStatusSelector = (row, hold, item, column) => {
  const possibleStatuses = holdKey.map(type => {
    return {
      value: type,
      label: getReadableHoldStatus({status: type})
    }
  })

  const holdStyle = getStatusStyle(hold.status)

  const height = "24px"
  return (
      <Select
        className="w-full"
        value={possibleStatuses.find(x => x.value == hold.status)}
        options={possibleStatuses.filter(x=>x.value != "received")}
        classNamePrefix="sg-manifest-status-select"
        isSearchable={false}
        styles={{
          control: (provided, state) => ({
            ...provided,
            height: height,
            minHeight: height,
            border: "0",
            borderRadius: "0",
            background: holdStyle["backgroundColor"],
          }),
           singleValue: provided => ({
            ...provided,
            fontWeight: "bold",
            color: holdStyle["color"],
          }),
          menu: (base) => ({
                ...base,
                width: "max-content",
                minWidth: "100%"
          }),
          indicatorSeparator: base => ({
            ...base,
            display: 'none'
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            height: height,
            padding: '0 6px',
            color: holdStyle["color"],
          }),
           indicatorsContainer: (provided, state) => ({
            ...provided,
            height: height,
          }),
        }}
        onChange={({value, label}) => {
          row.updateItemHold(hold.id, {status: value})
        }}
        isDisabled={hold.status == "received" || row.disabled_input}
      />
  );
}
export const renderItemCell = (item, column) => {
  return (
    <div className="sg-contained-item flex">
      <div className="float-left">
        <ItemImageGalleryModal
          button={(
            <div>
              <img className="w-[72px] h-[72px] object-cover" src={(item.active_image||{}).image} />
              <br/>
              {item.active_image ? (
                <button  className="link-button text-[#3070E7] text-[9px] font-bold font-italic italic" onclick="return false;">
                  View Larger
                </button>
              ):""}
            </div>
          )}
          currentImage={item.active_image}
          images={[]}
        />
  
      </div>
      <div className="inline-block pl-4">
        <a href={`/items/${item.id}`} target="_blank">{item.name}</a>
        <div className="pt-2"/>
        Categories{" "}
        {item.category ? item.category.group_name||"Other" : "Other"}
        {" / "}
        {item.category ? item.category.name||"Other" : "Other"}
        {item.direct_to_site > 0 ? (
          <div className="text-[#E60073] font-bold">
            Direct To Site: {item.direct_to_site}
          </div>
        ):""}
        {item.order_not_finalized > 0 ? (
          <div className="text-[#E60073] font-bold">
            Orders Not Finalized
          </div>
        ):""}     

      </div>

    </div>
  )
}

const renderHoldCell = (item, column, render = ()=>{}) => {
  return item.reserved_holds.map(hold=> {
    return (
      <div className="sg-manifest-table-hold-cell">
        {render(hold, item, column)}
      </div>
    )
  })
}

export const hasReturnedRowBeenAdjusted = (row) => {
  return row.damaged > 0 || row.extra > 0 || row.warehouse_received > 0 || row.lost_or_consumed > 0
}

export const getReturnsColumns = () => {
  return [
    {
      id: "item",
      label: "Item",
      renderCell: renderItemCell,
      valueGetter: (row, column) => {
        return row.name
      },
      customSort: (rows, column, sortDirection)=>{ 
        return rows.sort((a, b)=>{
          let aName = (a.name||"").toLowerCase()
          let bName = (b.name||"").toLowerCase()
          //If a starts with a number
          if(aName[0] >= '0' && aName[0] <= '9') {
            aName = "zzzzzz"+aName
          }
          if(bName[0] >= '0' && bName[0] <= '9') {
            bName = "zzzzzz"+bName
          }
          if(sortDirection == "asc") {
            return aName < bName ? -1 : 1
          }else {
            return aName > bName ? -1 : 1
          }
          
        })
      },
      renderCellExport: (row, column) => {
        return row.name
      },
      width: 300
    },
    {
      id: 'owner',
      label: "Owner",
      cellClassName:"font-bold",
    },
    {
      id: "onsite_notes",
      label: "Onsite Notes",
      cellClassName:"px-4",
      sorting: false,

      valueGetter: (row, column) => {
        return row.onsite_notes 
      },
      valueSetter: (row, column, value) => {
        row.updateItemHold(row.id, {onsite_notes: value})
      },
      renderCellExport: (row, column) => {
        return row.reserved_holds.map(hold=> {
          return hold.onsite_collected
        }).join(",\n")
      },
      renderCell: (row, column) => (
        renderHoldCell(row, column, (hold, item, column) => {
          return renderEditableTextField(hold, column, {fieldProps: {
            disabled: row.disabled_input,
            multiline: true,
            maxHeight: "29px"
          }})
        })
      )
    },
    {
      id: "return_notes",
      label: "Return Notes",
      valueGetter: (row, column) => {
        return (row.event_item_fields||{}).return_notes||""
      },
      valueSetter: (row, column, value) => {
        row.updateEventItemField(row.event_item_fields.id, {return_notes: value})
      },
      renderCell: (row, column) => (
        renderEditableTextField(row, column, {fieldProps: {
          multiline: true,
          disabled: row.disabled_input
        }})
      ),
      cellClassName: "px-4"
    },
    {
      id: "qty-shipped",
      label: "QTY Shipped",
      cellClassName:"font-bold",
      valueGetter: (row, column) => {
        return row.hold?.total_packed || 0
      }
    },
    {
      id: "returned",
      label: "Returned",
      cellClassName: "font-bold",
      valueGetter: (row, column) => {
        return row.event_item_fields.warehouse_received||0
      },
      renderCell: (row) => {
        const hasReturnedRowBeenAdjustedResult = hasReturnedRowBeenAdjusted(row.event_item_fields)
        if(hasReturnedRowBeenAdjustedResult) {
          return row.event_item_fields.warehouse_received
        }else {
          return (
            <div
              className="font-bold w-full h-full text-center bg-red-500 text-white p-3"
            >
              Return Not Started
            </div>
          )
        }
      }
    },
    {
      id: "damaged",
      label: "Damaged",
      cellClassName: "font-bold sg-manifest-returns-light-cell",
      valueGetter: (row, column) => {
        return row.event_item_fields.damaged||0
      }
    },
    {
      id: "lost-consumed",
      label: "Lost/Consumed",
      cellClassName: "font-bold sg-manifest-returns-light-cell",
      valueGetter: (row, column) => {
        return row.event_item_fields.lost_or_consumed||0
      }
    },
    {
      id: "extra",
      label:"Added On-Site",
      cellClassName: "font-bold sg-manifest-returns-light-cell",
      valueGetter: (row, column) => {
        return row.event_item_fields.extra||0
      }
    },
    {
      id: "actions",
      label:"",
      disableExport: true,
      renderCell: (row, column) => {
        return (
          !!row.event.manifest_return_completed_at || row.disabled_input ? "" : (
            <button onClick={()=>{
              row.openManifestReturnsModal(row.id)
            }}className="btn-outlined btn-filled">
              EDIT
            </button>
          )
   
        )
      }
    }

  ]
}